import { AfterViewInit, Component, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { BaseComponent } from '../../base.component';
//import { MapCatalogComponent } from '../map-catalog/map-catalog.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
  selector: 'mc-merge-map-action',
  templateUrl: './merge-map-action.component.html',
    styleUrls: ['../../sharedStyles/base.scss', './merge-map-action.component.scss']
})
export class MergeMapActionComponent  extends BaseComponent implements AfterViewInit {
    constructor(_vcr: ViewContainerRef) { super(_vcr, true); }

    ngAfterViewInit() {
        this.isReady();
    }

    mergeMap() {
        const win: any = window.document.getElementById('mapCatalogWindow');
        if (win) {
            const mapCatalog = win.firstElementChild; // as MapCatalogComponent; // todo TFS#13854
            mapCatalog.mergeMaps = true;
            win.open();
        }
    }
}
